// سفرة تاتا وصال: the game (game.ts), over a pack read from its file.
// The page names the file (<meta name="pack">; pack.json beside it otherwise),
// and the address may name another (?pack=../f/<slug>/pack.json), which is
// how a pack is tried on a page that is not its own — and how the app opens
// a family's sofra, on this page, from the pack it keeps. Danny's and every
// family's page load this one bundle; what differs is the file (pack.ts).
import {asset} from '../../core/assets';
import {$} from '../../core/util';
import {loadPack,type PageCfg,type TataPack} from './pack';
import {play} from './game';

// The page's own pack goes through the resolver, so that in the app a newer
// kept copy of it is the one read (core/store.ts, snapshot); a pack named on
// the address is taken as it is, since the app names a kept file there.
const q=new URLSearchParams(location.search);
const url=q.get('pack')??asset(document.querySelector<HTMLMetaElement>('meta[name="pack"]')?.content??'pack.json');
// What the pack's own page would have said, said by this one: on a family's
// page it is what is already there; on another, it is theirs.
function dress(p:PageCfg){
  const root=document.documentElement; root.lang=p.lang; root.dir=p.dir; document.title=p.title;
  const hint=$('hint'); hint.textContent=p.hint; hint.lang=p.lang;
  if(p.font)$('ui').style.fontFamily=p.font;
}
loadPack(url).then((p:TataPack)=>{if(p.PAGE)dress(p.PAGE);play(p);}).catch(err=>{console.error(err);throw err;});
